import * as React from "react";
import { Badge } from "@mui/material";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { Dayjs } from "dayjs";

type Props = PickersDayProps<Dayjs> & {
  bookingDays?: Set<string>; // Set of "YYYY-MM-DD"
};

export default function PreneedCalendarDayWithDot(props: Props) {
  const { day, outsideCurrentMonth, bookingDays, ...other } = props;

  const key = day.format("YYYY-MM-DD");

  //  IMPORTANT: bookingDays may be undefined; treat as empty.
  const hasBooking = bookingDays ? bookingDays.has(key) : false;

//   console.log("bookingDays size", bookingDays?.size, "key", key, "hasBooking", hasBooking);


  return (
    <Badge
      overlap="circular"
      variant="dot"
      //  dot visible only when booking exists & inside month
      invisible={!hasBooking || outsideCurrentMonth}
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: "#f4b400",
          color: "#f4b400",
          right: "50%",
          top: "82%",
          transform: "translateX(50%)",
        },
      }}
    >
      <PickersDay {...other} day={day} outsideCurrentMonth={outsideCurrentMonth} />
    </Badge>
  );
}
